import { Navigate } from "react-router";
import { useAuth } from "@/modules/auth";

export default function IndexRedirect() {
	const { loading, isAuthenticated, isNameAvailable, isBrandAvailable, currentWorkspaceId } = useAuth();

	// Still resolving auth
	if (loading) {
		return null;
	}

	// Not authenticated
	if (!isAuthenticated) {
		return <Navigate to="/login" replace />;
	}

	// Onboarding flow
	if (!isNameAvailable) {
		return <Navigate to="/onboarding/complete-profile" replace />;
	}

	if (isNameAvailable && !isBrandAvailable) {
		return <Navigate to="/onboarding/create-brand" replace />;
	}

	// Fully setup with workspace selected
	if (currentWorkspaceId) {
		return <Navigate to={`/${currentWorkspaceId}/dashboard`} replace />;
	}

	// No workspace selected - go to brands page (auto-selection handled by PublicGuard)
	return <Navigate to="/brands" replace />;
}
